import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SparklesIcon, StarIcon, FilmIcon } from '@heroicons/react/24/solid';
import { cn } from '../utils/cn';

const TIER_CONFIG = {
  free:         { label: 'Free',         icon: SparklesIcon, classes: 'bg-gray-100 text-gray-700 border border-gray-300' },
  oneoff:       { label: 'Pay-Per-Video', icon: FilmIcon,     classes: 'bg-brand-blue/10 text-brand-blue border border-brand-blue/30' },
  subscription: { label: 'Subscription', icon: StarIcon,     classes: 'bg-gradient-to-r from-primary-500 to-primary-700 text-white shadow-md' },
  // legacy alias
  premium:      { label: 'Subscription', icon: StarIcon,     classes: 'bg-gradient-to-r from-primary-500 to-primary-700 text-white shadow-md' },
};

const TierBadge = ({ tier = 'free', size = 'md', showIcon = true, className = '', clickable = true }) => {
  const navigate = useNavigate();
  const config = TIER_CONFIG[tier] || TIER_CONFIG.free;
  const Icon = config.icon;

  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1.5',
    lg: 'text-base px-4 py-2',
  };

  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5',
  };

  const classes = cn(
    'inline-flex items-center gap-1.5 font-button font-semibold uppercase tracking-wide transition-all duration-200',
    config.classes,
    sizeClasses[size],
    clickable && 'cursor-pointer hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-600 focus-visible:ring-offset-2',
    className
  );

  const content = (
    <>
      {showIcon && <Icon className={iconSizes[size]} />}
      <span>{config.label}</span>
    </>
  );

  if (clickable) {
    return (
      <button
        type="button"
        onClick={() => navigate('/subscription')}
        className={classes}
        style={{ borderRadius: 0 }}
        aria-label="Manage subscription"
      >
        {content}
      </button>
    );
  }

  return (
    <span className={classes} style={{ borderRadius: 0 }}>
      {content}
    </span>
  );
};

export default TierBadge;
